class ProductAccordion extends HTMLElement {
    constructor() {
        super();
        this.items = [];
    }

    connectedCallback() {
        // Wait for DOM to be ready
        setTimeout(() => this.init(), 0);
    }

    init() {
        this.items = Array.from(this.querySelectorAll('.accordion-item'));
        
        this.items.forEach(item => {
            const header = item.querySelector('.accordion-header');
            const content = item.querySelector('.accordion-content');
            const isOpen = item.getAttribute('data-open') === 'true';

            if (header && content) {
                // Initialize state
                if (isOpen) {
                    item.classList.add('active');
                }

                header.addEventListener('click', () => this.toggleItem(item));
            }
        });
    }

    toggleItem(targetItem) {
        const isAlreadyActive = targetItem.classList.contains('active');
        
        // Optional: Close other items (uncomment if you want accordion behavior)
        /*
        this.items.forEach(item => {
            if (item !== targetItem) {
                item.classList.remove('active');
            }
        });
        */

        targetItem.classList.toggle('active', !isAlreadyActive);
    }
}

if (!customElements.get('product-accordion')) {
    customElements.define('product-accordion', ProductAccordion);
}
